<template>
	<el-dialog title="修改密码" :visible.sync="visible" width="500px" :close-on-click-modal="false" top="30vh" :before-close="close"
	@close="close">
		<el-form :model="form">
			<el-form-item label="旧密码" :label-width="formLabelWidth">
				<el-input type="password" v-model="form.oldpassword" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="新密码" :label-width="formLabelWidth" style="margin-top: 20px;">
				<el-input type="password" v-model="form.newpassword" autocomplete="off"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer" >
			<el-button @click="close">取 消</el-button>
			<el-button type="primary" @click="submit">确 定</el-button>
		</div>
	</el-dialog>
</template>
<style scoped>


</style>
<script>
	export default {
		props: {
			visible: {
				type: Boolean,
				defalut: () => {
					return false
				}
			}
		},
		data() {
			return {
				formLabelWidth: '80px',
				form: {
					oldpassword: '',
					newpassword: '',
				},
			}
		},
		watch: {

		},
		computed: {

		},
		mounted() {

		},
		methods: {
			close() {
				this.form.oldpassword = this.form.newpassword = ''
				this.$emit('close')
			},
			submit() {
				this.$api.changePassword(this.form).then(() => {
					this.$message({
						message: '修改成功',
						type: 'success'
					})
					window.localStorage.removeItem(this.$store.state.token)
					this.$router.push('/login')
				})
			}
		}
	}
</script>
